import once from 'lodash-es/once';
import setupLogRocketReact from 'logrocket-react';
import LogRocket from 'logrocket';

// there's currently an internal bug that causes
// logrocket-react to throw Minified React error #102 if it's invoked twice,
// so this is to ensure that it is only ever invoked once
export default once(() => setupLogRocketReact(LogRocket));
